import { NotificationPermissionStatus } from '../models/NotificationPermission';

export class PermissionManager {
    /**
     * Get current permission granted by the user for the current origin to display web notifications.
     */
    static getNotificationPermission(): NotificationPermission | undefined {
        return window.Notification.permission;
    }

    static isDenied(permission?: NotificationPermission | null): boolean {
        return (permission ?? PermissionManager.getNotificationPermission()) === NotificationPermissionStatus.Denied;
    }

    static isGranted(permission?: NotificationPermission | null): boolean {
        return (permission ?? PermissionManager.getNotificationPermission()) === NotificationPermissionStatus.Granted;
    }

    static isDefault(permission?: NotificationPermission | null): boolean {
        const curPermission: NotificationPermission | undefined =
            permission ?? PermissionManager.getNotificationPermission();

        return !curPermission || curPermission === NotificationPermissionStatus.Default;
    }
}
